import { authFetch, BASE_BACKEND_URL } from '../../auth'
import * as apiStatusCodes from '../../constants/apiStatusCodes'

export const getProductInfoToCreate = () => {
  const url = `${BASE_BACKEND_URL}/products/new`
  return sendApiRequest('GET', url)
}

const sendApiRequest = (method, url, params) =>
  authFetch(url, {
    method: method,
    body: JSON.stringify(params)
  })

export const getBusiness = () => {
  const url = `${BASE_BACKEND_URL}/admin/businesses`
  return sendApiRequest('GET', url)
}

export const handleErrors = (response) =>
  new Promise((resolve, reject) => {
    if (!response || (response.status !== apiStatusCodes.OK && response.status !== apiStatusCodes.CREATED)) {
      reject(response)
    } else {
      resolve(response)
    }
  })

export const updateUserInfo = (id, value) => {
  const url = `${BASE_BACKEND_URL}/admin/users/${id}`
  const params = {
    name: value.name,
    active: value.active,
    email: value.email,
    mobile: value.mobile
  }
  return sendApiRequest('PUT', url, params)
}

export const sendEmail = (user, action) => {
  const url = `${BASE_BACKEND_URL}/admin/send_email_to_user`
  const params = {
    email: user.email,
    key: user.password,
    email_type: action
  }
  return sendApiRequest('POST', url, params)
}

export const resetPassword = (user) => {
  const url = `${BASE_BACKEND_URL}/admin/update_password`
  const params = {
    email: user.email,
    key: user.password,
    key_confirmation: user.password_confirmation
  }
  return sendApiRequest('POST', url, params)
}

export const getQueryState = () => {
  if (window.location.href.indexOf('query') >= 0) {
    return decodeURI(
      window.location.href.split('query=')[window.location.href.split('query=').length - 1]
    )
  } else {
    return ''
  }
}

export const getFormattedDate = (createdDate) => {
  const d = new Date(createdDate)
  return d.toLocaleString()
}
